// Editable site text for the fenêtre-volable app, sourced from the unified
// admin hub (paramoteur.treevolta.com/admin). Single source of truth; falls
// back to baked-in defaults until the hub responds.
import { useState, useEffect } from "react";

const DEFAULTS = {
  nav: { ecole: "🎓 École Paramoteur", weather: "🌤️ Météo", flyable: "🪂 Fenêtre volable" },
};

type FlyCms = typeof DEFAULTS;
let cache: FlyCms | null = null;

export function useFlyableCms(): FlyCms {
  const [c, setC] = useState<FlyCms>(cache || DEFAULTS);
  useEffect(() => {
    if (cache) { setC(cache); return; }
    fetch("https://paramoteur.treevolta.com/api/content-flyable")
      .then((r) => (r.ok ? r.json() : null))
      .then((d: any) => {
        if (d && d.nav) { cache = { nav: { ...DEFAULTS.nav, ...d.nav } }; setC(cache); }
      })
      .catch(() => {});
  }, []);
  return c;
}
